import api from '@/services/api'

const RESOURCE_URI = '/operation'

const operationToFormData = (operation) => {
  const formData = new FormData()

  Object.entries(operation).forEach(([key, value]) => {
    if (value !== null && typeof value !== 'undefined') {
      formData.append(key, value)
    }
  })

  return formData
}

const requestConfig = {
  headers: { 'Content-Type': 'multipart/form-data' }
}

const fetchOperations = ({ checkoutId, type, paymentId } = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(
      Object.entries({ checkoutId, type, paymentId }).filter(
        ([, value]) => typeof value !== 'undefined'
      )
    )
  ).toString()

  return api.get([`${RESOURCE_URI}`, query].join('?'))
}

const fetchBankDeposits = ({
  storeId,
  checkoutId,
  fromDate,
  toDate,
  receiptStatus
} = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(
      Object.entries({
        storeId,
        checkoutId,
        fromDate,
        toDate,
        receiptStatus,
        category: 'bankDeposit'
      }).filter(([, value]) => typeof value !== 'undefined' && value !== null)
    )
  ).toString()

  return api.get([`${RESOURCE_URI}`, query].join('?'))
}

const fetchCashExpenses = ({
  storeId,
  checkoutId,
  fromDate,
  toDate,
  receiptStatus
} = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(
      Object.entries({
        storeId,
        checkoutId,
        fromDate,
        toDate,
        receiptStatus,
        type: 'expense',
        category: 'manual',
        paymentId: 'null'
      }).filter(([, value]) => typeof value !== 'undefined' && value !== null)
    )
  ).toString()

  return api.get([`${RESOURCE_URI}`, query].join('?'))
}

const createOperation = (operation) => {
  if (operation.receiptPhoto) {
    return api.post(RESOURCE_URI, operationToFormData(operation), requestConfig)
  }

  return api.post(RESOURCE_URI, operation)
}

const updateOperation = ({ id, ...operation }) => {
  if (operation.receiptPhoto) {
    return api.put(
      `${RESOURCE_URI}/${id}`,
      operationToFormData(operation),
      requestConfig
    )
  }

  return api.put(`${RESOURCE_URI}/${id}`, operation)
}

const attachReceipt = ({ id, receiptPhoto }) =>
  api.put(
    `${RESOURCE_URI}/${id}/receipt`,
    operationToFormData({ receiptPhoto }),
    requestConfig
  )

const deleteOperation = (id) => api.delete(`${RESOURCE_URI}/${id}`)

export default {
  fetchOperations,
  fetchBankDeposits,
  fetchCashExpenses,
  createOperation,
  updateOperation,
  attachReceipt,
  deleteOperation
}
